import { render } from "./InstanceSettings.vue?vue&type=template&id=f35f8f38"
import script from "./InstanceSettings.vue?vue&type=script&lang=js"
export * from "./InstanceSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__